// This component is for coverage tab in Application form 
// To add coverage based on plan class and practice counties
<template>
  <div class="bg-gray-50 shadow px-4 py-5 sm:rounded sm:p-6 coverage-tab">
    <div class="md:grid md:grid-cols-2 md:gap-6 sm:px-6">
      <div class="md:col-span-3">
        <h3 class="text-lg font-medium leading-6 text-gray-900 mt-2">COVERAGES</h3>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <form @submit.prevent="submitApplication" novalidate class="space-y-6">
          <div
            class="shadow sm:rounded-md sm:overflow-hidden xl:w-4/5 md:w-full sm:w-full coverage-div"
          >
            <div class="bg-white py-6 px-4 space-y-6 sm:p-2">
              <div class="barley-corn-bg-color-3 border-l-4 cobalt-border-color-3 p-4 text-[#1f3341]">
                <i class="fa fa-info-circle text-[#1f3341]"></i>
                Please review the Fee Schedule before you make your coverage
                selections. You can view our Fee Schedule as a PDF or you can
                view it by clicking the Fee Schedule hyperlinks below for each
                legal coverage.
                <br />
                <br />Please note that coverage will vary depending on the member’s
                plan. You must contact our Authorizations Department prior to
                proceeding with a member’s legal matter in order to determine
                the member’s coverage.
                <div class="tooltip mt-1" v-if="form.stateCount['Others'] > 0">
                  USL Fee Schedule
                  <span>- Standard</span>
                  <a
                    :href="
                      API_BASE +
                        'downloadAggreementFiles.php?name=USL Fee Reimbursement Schedule - Standard.pdf&folder=agreement_pdfs'
                    "
                  >
                    <i class="ml-2 fa fa-download cobalt-text-color cursor-pointer"></i>
                  </a>
                  <span class="tooltip-text">Download</span>
                </div>
                <div class="tooltip mt-1" v-if="form.stateCount['CA'] > 0">
                  USL Fee Schedule - California
                  <a
                    :href="
                      API_BASE +
                        'downloadAggreementFiles.php?name=USL Fee Reimbursement Schedule - California.pdf&folder=agreement_pdfs'
                    "
                  >
                    <i class="ml-1 fa fa-download cobalt-text-color cursor-pointer"></i>
                  </a>
                  <span class="tooltip-text">Download</span>
                </div>
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label class="block text-sm font-medium text-gray-900" for="date_admitted_to_bar">
                  Attorney Type
                  <span class="text-red-500">*</span>
                </label>
                <label
                  v-for="(item, index) in attorney_types"
                  :key="index"
                  class="inline-flex items-center mt-3 ml-2"
                >
                  <input
                    type="checkbox"
                    :value="item.id"
                    :id="'attorney_type' + index"
                    v-model="form.attorney_type"
                    @change="getCoverages(item.id)"
                    class="focus:ring-indigo-500 h-6 w-6 cobalt-text-color border-gray-300 rounded"
                  />
                  <span class="ml-2 text-gray-800">{{ item.name }}</span>
                </label>
                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.attorney_type.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                </div>
              </div>
              <div class="barley-corn-bg-color-3 border-l-4 cobalt-border-color-3 p-4 text-[#1f3341]">
                <ul class="list-disc ml-5">
                  <li>
                    Family Defender (
                    <b>FAM</b> Plan Class) - You will accept
                    matters that will be paid out in accordance with the
                    corresponding U.S. Legal Services Inc. Attorney Fee
                    Schedule. Please indicate all areas of practice in which you
                    will accept matters that will be paid out in accordance with
                    the corresponding U.S. Legal Services Inc. Attorney Fee
                    Schedule. Also, please indicate whether you have the
                    capability to provide legal services 100% remotely for each
                    area of coverage in which you elect to provide services.
                  </li>
                  <br />
                  <li>
                    CDL Defender (
                    <b>CDL</b> Plan Class) - You will accept CDL
                    covered cases and/or CDL referral cases. Please indicate if
                    you will accept CDL covered cases and/or CDL referral cases.
                  </li>
                  <br />
                  <li>
                    Referral (
                    <b>REF</b> Plan Class) - You will accept referrals
                    of U. S. Legal plan members to provide a free consultation
                    and bill the member directly at a discount of at least 33%
                    off your normal hourly rate for Non-Covered legal services.
                    Please indicate the practice areas for which you will accept
                    referrals of U. S. Legal plan members to provide a free
                    consultation and bill the member directly at a discount of
                    at least 33% off your normal hourly rate for Non-Covered
                    legal services.
                  </li>
                  <br>
                  <li>
                    <b>Remote Consulting</b> - you can provide consultations remotely.
                  </li>
                  <br>
                  <li>
                  <b>Remote Services</b> - you can provide services (past the initial consultation) remotely.
                  </li>
                </ul>
              </div>
              <h3 class="text-lg leading-6 font-medium text-gray-900">Coverages</h3>
              <div class="overflow-x-auto">
                <table class="divide-y divide-gray-200 w-full">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        style="width:56%"
                      >Coverage</th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >Plan Class</th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider xl:w-1/5 md:w-32"
                      >Remote Consulting</th>
                    <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider xl:w-1/5 md:w-32"
                      >Remote Services</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="(item, i) in coverages" :key="i">
                      <td
                        colspan="4"
                        v-if="
                        item.sub_coverage &&
                          item.sub_coverage[0]['subcoverage'] != '' &&
                          item.sub_coverage.length > 1
                      "
                      >
                        <div class="tab overflow-hidden border-t">
                          <!-- <a
                            v-show="form.attorney_type.includes('FAM')"
                            href="javascript:;"
                            class="border-b-2 barley-corn-border-color mt-4 inline-flex items-center px-1 py-1 font-medium"
                            @click="openfeeSchedule(true, item)"
                            v-if="item.fee_schedule.length > 0"
                          >Fee Schedule</a> -->
                          <a
                            href="javascript:;"
                            class="mt-7 inline-flex items-center px-1 py-1 font-medium"
                            @click="openfeeSchedule(true, item)"
                            v-if="item.fee_schedule.length > 0 && !form.attorney_type.includes('FAM')"
                          ></a>

                          <input
                            class="absolute opacity-0 tab-checkbox"
                            :id="'tab-multi-one' + i"
                            type="checkbox"
                            name="tabs"
                          />
                          <label
                            class="block p-5 leading-normal cursor-pointer float-left"
                            :for="'tab-multi-one' + i"
                            :style="[form.attorney_type.includes('FAM') ? {'width':'45%'} : {'width':'55%'}]"
                          >
                            <span>
                              {{ item.desc }}
                              <span v-if="item.is_required" class="text-red-500">*</span>
                            </span>
                          </label>

                          <label
                            class="p-6 ml-3"
                            v-for="(item2, index1) in item.plan_class"
                            :key="index1"
                          >
                            <input
                              :id="'coverage_' + i + '_' + index1"
                              type="checkbox"
                              @change="
                            check(
                              { plan_class: item2, desc: item.desc },
                              'coveragelist',
                              $event
                            )
                          "
                              class="focus:ring-indigo-500 h-6 w-6 cobalt-text-color border-gray-300 rounded"
                            />
                            <span class="ml-2 text-gray-800">{{ item2 }}</span>
                          </label>

                          <div
                            class="tab-content border-l-2 bg-gray-50 border-indigo-500 leading-normal"
                          >
                            <table class="p-5 table-auto" style="width:100%">
                              <th class="text-start text-xs font-medium text-gray-500 uppercase">SUB-COVERAGES</th>
                              <th class="text-start text-xs font-medium text-gray-500 uppercase">PLAN CLASS</th>
                              <th class="text-start text-xs font-medium text-gray-500 uppercase">REMOTE CONSULTING</th>
                              <th class="text-start text-xs font-medium text-gray-500 uppercase">REMOTE SERVICES</th>
                              <tr v-for="(item1, index) in item.sub_coverage" :key="index">
                                <td
                                  class="px-3 py-3 w-2/4"
                                  v-if="
                                  (form.attorney_type.includes('REF') &&
                                    item1.plan_class == 'REF') ||
                                    (form.attorney_type.includes('REF') &&
                                      item1.plan_class != 'REF') ||
                                    (!form.attorney_type.includes('REF') &&
                                      item1.plan_class != 'REF')
                                "
                                >
                                  <span
                                    v-if="
                                    item.desc == 'Guardianship/Conservatorship'
                                  "
                                  >{{ item1.subcoverage }}</span>
                                  <span
                                    v-if="
                                    item.desc != 'Guardianship/Conservatorship'
                                  "
                                  >
                                    {{ item.desc }} -
                                    {{ item1.subcoverage }}
                                  </span>
                                </td>
                                <td
                                  class="px-9 py-3"
                                  v-if="
                                  (form.attorney_type.includes('REF') &&
                                    item1.plan_class == 'REF') ||
                                    (form.attorney_type.includes('REF') &&
                                      item1.plan_class != 'REF') ||
                                    (!form.attorney_type.includes('REF') &&
                                      item1.plan_class != 'REF')
                                "
                                >
                                  <label
                                    class="xl:p-6 md:p-2"
                                    v-for="(item2, index1) in item.plan_class"
                                    :key="index1"
                                  >
                                    <input
                                      type="checkbox"
                                      :id="
                                      'coverage_' +
                                        i +
                                        '_' +
                                        index +
                                        '_' +
                                        index1
                                    "
                                      @change="
                                      check(
                                        {
                                          plan_class: item2,
                                          desc: item.desc,
                                          sub_cov_id: item1.sub_cov_id,
                                          sub_coverage: item1.subcoverage,
                                        },
                                        'coveragelist',
                                        $event
                                      )
                                    "
                                      class="focus:ring-indigo-500 h-6 w-6 cobalt-text-color border-gray-300 rounded"
                                    />
                                    <span class="ml-2 text-gray-800">
                                      {{
                                      item2
                                      }}
                                    </span>
                                  </label>
                                </td>
                                <td
                                  class="py-3 text-center"
                                  style="width:250px;"
                                  v-if="
                                  (form.attorney_type.includes('REF') &&
                                    item1.plan_class == 'REF') ||
                                    (form.attorney_type.includes('REF') &&
                                      item1.plan_class != 'REF') ||
                                    (!form.attorney_type.includes('REF') &&
                                      item1.plan_class != 'REF')
                                "
                                >
                                  <div
                                    class="relative inline-block w-10 mr-16 align-middle select-none transition duration-200 ease-in"
                                  >
                                    <input
                                      type="checkbox"
                                      name="toggle"
                                      :id="'toggle_' + i + '_' + index"
                                      @change="
                                      check(
                                        {
                                          plan_class: item.plan_class,
                                          desc: item.desc,
                                          sub_coverage: item1.subcoverage,
                                        },
                                        'remote_consulting',
                                        $event
                                      )
                                    "
                                      :disabled="
                                      !form?.coveragelist?.some(
                                        (el) => el.desc === item.desc
                                      ) ||
                                        !form.coveragelist.some(
                                          (el) =>
                                            el.sub_coverage ===
                                            item1.subcoverage
                                        )
                                    "
                                      class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
                                    />
                                    <label
                                      :id="'toggle_' + i + '_' + index"
                                      class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
                                    ></label>
                                  </div>
                                </td>
                                <td
                                  class="py-3 text-center"
                                  style="width:250px;"
                                  v-if="
                                  (form.attorney_type.includes('REF') &&
                                    item1.plan_class == 'REF') ||
                                    (form.attorney_type.includes('REF') &&
                                      item1.plan_class != 'REF') ||
                                    (!form.attorney_type.includes('REF') &&
                                      item1.plan_class != 'REF')
                                "
                                >
                                  <div
                                    class="relative inline-block w-10 mr-16 align-middle select-none transition duration-200 ease-in"
                                  >
                                    <input
                                      type="checkbox"
                                      name="toggle_service"
                                      :id="'toggle_service' + i + '_' + index"
                                      @change="
                                      check(
                                        {
                                          plan_class: item.plan_class,
                                          desc: item.desc,
                                          sub_coverage: item1.subcoverage,
                                        },
                                        'remote_services',
                                        $event
                                      )
                                    "
                                      :disabled="
                                      !form?.coveragelist?.some(
                                        (el) => el.desc === item.desc
                                      ) ||
                                        !form.coveragelist.some(
                                          (el) =>
                                            el.sub_coverage ===
                                            item1.subcoverage
                                        )
                                    "
                                      class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
                                    />
                                    <label
                                      :id="'toggle_service' + i + '_' + index"
                                      class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
                                    ></label>
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </td>
                      <td
                        v-if="
                        !item.sub_coverage ||
                          item.sub_coverage[0]['subcoverage'] == '' ||
                          item.sub_coverage.length <= 1
                      "
                        class
                      >
                        <label class="block p-5 leading-normal cursor-pointer">
                          {{ item.desc }}
                          <span v-if="item.is_required" class="text-red-500">*</span>
                          <!-- <a
                            v-show="form.attorney_type.includes('FAM') && item.desc!='CDL' && item.desc!='CDL Referral'"
                            href="javascript:;"
                            class="float-right border-b-2 barley-corn-border-color inline-flex items-center px-1 py-1 font-medium"
                            @click="openfeeSchedule(true, item)"
                            v-if="item.fee_schedule.length > 0"
                          >Fee Schedule</a> -->
                        </label>
                      </td>

                      <td
                        style="width: 330px;"
                        v-if="
                        !item.sub_coverage ||
                          item.sub_coverage[0]['subcoverage'] == '' ||
                          item.sub_coverage.length <= 1
                      "
                        class
                      >
                        <label class="p-3" v-for="(item2, index1) in item.plan_class" :key="index1">
                          <input
                            :id="'coverage_' + i + '_' + index1"
                            type="checkbox"
                            @change="
                            check(
                              { plan_class: item2, desc: item.desc },
                              'coveragelist',
                              $event
                            )
                          "
                            class="focus:ring-indigo-500 h-6 w-6 cobalt-text-color border-gray-300 rounded"
                          />
                          <span class="ml-2 text-gray-800">{{ item2 }}</span>
                        </label>
                      </td>
                      <td
                        class="text-left"
                        v-if="
                        !item.sub_coverage ||
                          item.sub_coverage[0]['subcoverage'] == '' ||
                          item.sub_coverage.length <= 1
                      "
                      >
                        <div
                          class="relative inline-block w-10 ml-8 align-middle select-none transition duration-200 ease-in"
                        >
                          <input
                            type="checkbox"
                            name="toggle"
                            :id="'toggle_' + i"
                            @change="
                            check(
                              { plan_class: item.plan_class, desc: item.desc },
                              'remote_consulting',
                              $event
                            )
                          "
                            :disabled="
                            !form?.coveragelist?.some(
                              (el) => el.desc === item.desc
                            )
                          "
                            class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
                          />
                          <label
                            :for="'toggle_' + i"
                            class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
                          ></label>
                        </div>
                      </td>
                      <td
                        class="text-left"
                        v-if="
                        !item.sub_coverage ||
                          item.sub_coverage[0]['subcoverage'] == '' ||
                          item.sub_coverage.length <= 1
                      "
                      >
                        <div
                          class="relative inline-block w-10 ml-8 align-middle select-none transition duration-200 ease-in"
                        >
                          <input
                            type="checkbox"
                            name="toggle"
                            :id="'toggle_service' + i"
                            @change="
                            check(
                              { plan_class: item.plan_class, desc: item.desc },
                              'remote_services',
                              $event
                            )
                          "
                            :disabled="
                            !form?.coveragelist?.some(
                              (el) => el.desc === item.desc
                            )
                          "
                            class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
                          />
                          <label
                            :for="'toggle_service' + i"
                            class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
                          ></label>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="grid grid-cols-6 gap-4">
                <div class="col-span-6 sm:col-span-12">
                  <label
                    class="ml-6 text-md font-medium text-gray-900 float-left mr-5"
                    for="date_admitted_to_bar"
                  >
                    Referral Contingency/Federal or State Statute
                    <span class="text-red-500">*</span>
                  </label>

                  <div
                    class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in"
                  >
                    <input
                      type="checkbox"
                      name="toggle"
                      id="referral_cont_fee"
                      v-model="form.referral_cont_fee"
                      class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
                    />
                    <label
                      for="referral_cont_fee"
                      class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
                    ></label>
                  </div>
                  <p class="text-sm text-gray-500 ml-6">
                    Please note, plan coverage under this designation: Any case
                    in which attorney’s fees are recoverable on a contingency
                    basis or where fees for any attorney services required are
                    regulated by the attorney fee provisions of Federal and/or
                    State statute, the terms of said contingency agreement or
                    statutes shall control.
                  </p>
                  <div
                    class="text-red-600 mt-1 text-sm"
                    v-for="(error, index) in v$.form.referral_cont_fee.$errors"
                    :key="index"
                  >
                    <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-span-6 sm:col-span-3">
            <div class="shadow sm:rounded-md sm:overflow-hidden">
              <div class="bg-white border-b border-gray-400 py-5 px-4 sm:p-6">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                  Practice Area
                  <span class="text-red-500">*</span>
                </h3>
                <p class="mt-1 mb-4 text-sm text-gray-500">
                  Specify the State and County(ies) that you are willing to
                  provide service to our members. Select a State, then the
                  appropriate County and Plan Class, and click the plus button ( + ) to add it.
                </p>
                <div class="form-group grid grid-cols-6 gap-6 mt-2 mb-4">
                  <div class="col-span-6 sm:col-span-1">
                    <AutoComplete
                      class="h-10"
                      forceSelection
                      appendTo="body"
                      @item-select="onSelect($event, 'state')"
                      placeholder="State"
                      v-model="form.prac_state"
                      :dropdown="true"
                      :disabled="form?.coveragelist?.length <= 0"
                      :suggestions="state_list"
                      @complete="searchAutocomplete($event, 'state')"
                      field="state_name"
                    />
                  </div>
                  <div class="col-span-6 sm:col-span-1">
                    <AutoComplete
                      class="h-10"
                      appendTo="body"
                      forceSelection
                      placeholder="County"
                      :dropdown="true"
                      :disabled="form?.coveragelist?.length <= 0"
                      v-model="form.county"
                      :suggestions="county_list"
                      @complete="searchAutocomplete($event, 'county')"
                      field="COUNTYNAME"
                    />
                  </div>
                  <div class="col-span-6 sm:col-span-1">
                    <AutoComplete
                      class="h-10"
                      forceSelection
                      appendTo="body"
                      placeholder="Plan Class"
                      :dropdown="true"
                      :disabled="form?.coveragelist?.length <= 0"
                      v-model="form.att_plan_class"
                      :suggestions="att_plan_list"
                      @complete="
                        searchAutocomplete($event, 'attorney_planclass')
                      "
                      field="plan_class"
                    />
                  </div>
                  <div class="col-span-6 sm:col-span-1">
                    <button
                      type="button"
                      @click="add_county()"
                      class="inline-flex items-center p-1.5 border border-transparent rounded-full shadow-sm text-white barley-btn focus:outline-none focus:ring-2 focus:ring-offset-2"
                    >
                      <!-- Heroicon name: solid/plus -->
                      <svg
                        class="h-5 w-5"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <div class="flex flex-col">
                  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                      <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                          <thead class="bg-gray-50">
                            <tr>
                              <th
                                scope="col"
                                class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >State</th>
                              <th
                                scope="col"
                                class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >County</th>
                              <th
                                scope="col"
                                class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >Plan Class</th>
                              <th
                                scope="col"
                                class="px-6 w-32 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >
                                <span>
                                  <span class="float-left">CDL Rate</span>
                                  <p class="tooltip">
                                    <i class="fa fa-question-circle" aria-hidden="true"></i>
                                    <span class="tooltip-text">Only applicable for CDL plans</span>
                                  </p>
                                </span>
                              </th>
                              <th
                                scope="col"
                                class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >Action</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="(item, i) in form.practice_county_list" :key="i">
                              <td
                                class="px-6 py-4 whitespace-nowrap text-center"
                              >{{ item.state_code }}</td>
                              <td class="px-6 py-4 whitespace-nowrap text-center">{{ item.county }}</td>
                              <td
                                class="px-6 py-4 whitespace-nowrap text-center"
                              >{{ item.plan_class }}</td>
                              <td class="px-6 py-4 whitespace-nowrap text-center">
                                <text-input
                                  label
                                  v-bind:value="item.cdl_rate"
                                  :id="'cdl_rate' + i"
                                  v-on:keyup="
                                      item.cdl_rate = $event.target['value']
                                    "
                                  :class="{
                                      'bg-gray-100': item.plan_class != 'CDL',
                                    }"
                                  :disabled="item.plan_class != 'CDL'"
                                ></text-input>
                              </td>
                              <td
                                v-if="item.deleted == 1 || item.deleted == '1'"
                                class="px-6 py-4 whitespace-nowrap text-left text-sm font-medium text-center"
                              >
                                <button
                                  type="button"
                                  @click="addCounty(i)"
                                  class="mt-6 inline-flex items-center p-0.5 border border-transparent rounded-full shadow-sm text-white bg-[#ce4c29] hover:bg-[#ce4c29] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#ce4c29]"
                                >
                                  <svg
                                    class="h-5 w-5"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                                      clip-rule="evenodd"
                                    />
                                  </svg>
                                </button>
                                <div class>Deleted {{setDateFormat(item.date_deleted)}}</div>
                              </td>
                              <td
                                v-if="item.deleted != 1 && item.deleted != '1'"
                                class="px-6 py-4 whitespace-nowrap text-left text-sm font-medium text-center"
                              >
                                <button
                                  type="button"
                                  @click="ConfirmCountyDelete(i, item)"
                                  class="mt-6 inline-flex items-center p-0.5 border border-transparent rounded-full shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                >
                                  <svg
                                    class="w-5 h-5"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="3"
                                      d="M20 12H4"
                                    />
                                  </svg>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          class="text-red-600 mt-5 mb-5 text-sm ml-5"
                          v-for="(error, index) in v$.form.practice_county_list
                            .$errors"
                          :key="index"
                        >
                          <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div id="feeModal" class="hidden">
      <div
        tabindex="0"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
      >
        <div class="z-50 relative p-3 mx-auto my-0 max-w-full xl:w-3/5 md:w-full">
          <div class="bg-white px-4 mt-4 pt-5 pb-4 sm:p-6 sm:pb-4 rounded-lg">
            <div
              class="flex flex-row justify-between p-2 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg"
            >
              <p class="font-semibold text-gray-800">Fee Schedules - {{ fee_schedule_data?.desc }}</p>
              <i class="fa fa-close w-6 h-6 cursor-pointer" @click="openfeeSchedule(false)"></i>
            </div>
            <div class="flex flex-col px-6 py-5 bg-gray-50 fee-popup-scroll">
              <table class="divide-y divide-gray-200 w-full">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="w-1/2 px-4 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >Description</th>
                    <th
                      scope="col"
                      class="w-1/5 px-4 py-1 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >Rate($)</th>
                    <th
                      v-if="
                        form?.credentials?.some(
                          (el) => el.lic_state?.STATECD === 'CA'
                        )
                      "
                      scope="col"
                      class="w-1/5 px-4 py-1 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >CA(state) Rate($)</th>
                    <th
                      scope="col"
                      class="w-1/4 px-4 py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >Parameter</th>
                  </tr>
                </thead>
                <tbody
                  class="bg-white divide-y divide-gray-200 overflow-auto"
                  style="max-height: 500px;"
                >
                  <tr v-for="(item, index) in fee_schedule_data?.fee_schedule" :key="index">
                    <td class="px-2 py-2">{{ item.sub_coverage }}</td>
                    <td class="px-2 py-2 text-right">{{ item.fee_amount }}</td>
                    <td
                      class="px-2 py-2 text-right"
                      v-if="
                        form.credentials.some(
                          (el) => el.lic_state['STATECD'] === 'CA'
                        )
                      "
                    >{{ item.ca_fee_amount }}</td>
                    <td class="px-2 py-2 text-center">{{ item.parameter }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div
          class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
        ></div>
      </div>
    </div>
    <confirm-popup
      :showDeleteModal="showCountyDeleteModal"
      title="Delete"
      short_msg="Are you sure?"
      msg=" Do you really want to delete this county? This process cannot be undone."
      @click="cancelModal()"
      @remove="remove_county()"
    ></confirm-popup>
    <confirm-popup
      :showDeleteModal="showCovDeleteModal"
      title="Delete"
      short_msg="Are you sure?"
      msg=" Do you really want to delete this coverage? This process cannot be undone."
      @click="cancelModal()"
      @remove="remove_coverage()"
    ></confirm-popup>
  </div>
</template>
<style>
/* Css for this component for Accordions */
.coverage-div .tab-content {
  max-height: 0;
  -webkit-transition: max-height 0.35s;
  -o-transition: max-height 0.35s;
  transition: max-height 0.35s;
}
/* :checked - resize to full height */
.coverage-div .tab input:checked ~ .tab-content {
  max-height: 100vh;
  overflow: auto;
  width: 100%;
}
/* Label formatting when open */
.coverage-div .tab input:checked + label {
  font-size: 1.25rem; /*.text-xl*/
  border-left-width: 2px; /*.border-l-2*/
  border-color: #0054a6; /*.border-indigo*/
  background-color: #f8fafc; /*.bg-gray-100 */
  color: #0054a6; /*.text-indigo*/
}
/* Icon */
.coverage-div .tab label::after {
  float: right;
  top: 0;
  display: block;
  width: auto;
  height: auto;
  line-height: 1.5;
  font-size: 1.25rem;
  text-align: center;
  transition: all 0.35s;
  font-size: 16px;
  padding: 4px 15px;
  background-color: #ce4c29 !important;
  color: #fff;
}
.coverage-div .tab label:hover::after {
  background-color: #ce4c29 !important;
}
/* Icon formatting - closed */
.coverage-div .tab .tab-checkbox + label::after {
  content: "View Sub-coverages";
  font-weight: bold;
  border-width: 1px;
  border-radius: 10px;
  border-color: #ce4c29;
}

/* Icon formatting - open */
.coverage-div .tab .tab-checkbox:checked + label::after {
  /* transform: rotate(315deg); */
  background-color: #ce4c29 !important; /*.bg-indigo*/
  color: #f8fafc; /*.text-grey-lightest*/
}
</style>
<script>
import TextInput from "../Layout/Form/TextInput.vue"; // importing resuable input field
import ConfirmPopup from "../Layout/Modals/ConfirmPopup.vue"; // importing resuable delete modal
import useVuelidate from "@vuelidate/core"; // importing validation library
import { required } from "@vuelidate/validators"; // importing diffrene validation types from library.
import { mapState } from "vuex"; // importing mapState for get access state level variables.
import Constants from "../../constants.ts"; // importing constant resubale variables.
import moment from "moment-timezone";

export default {
  name: "AppCoverages",
  setup() {
    return { v$: useVuelidate() }; //creating object to access validation object.
  },
  props: ["forms"], // To access variable passed from Parent component.
  data: function() {
    // declaring static variable for this component
    return {
      form: this.forms,
      API_BASE: Constants.API_BASE,
      showCountyDeleteModal: false,
      deleteCountyIndex: "",
      deleteCountyData: {},
      errors: [],
      fee_schedule_data: [],
      state_list: [],
      att_plan_list: [],
      plan_list: [],
      coverages: [],
      county_list: [],
      attorney_types: [
        { id: "FAM", name: "Family Defender (FAM)" },
        { id: "CDL", name: "CDL Defender (CDL)" },
        { id: "REF", name: "Referral (REF)" }
      ],
      flag_options: [
        { id: 1, name: "Yes" },
        { id: 0, name: "No" }
      ]
    };
  },
  // use to import central level variables from store
  computed: mapState([
    "countyList",
    "att_user",
    "stateList",
    "profile_data",
    "tempAttData"
  ]),
  // validations
  validations: {
    form: {
      referral_cont_fee: { required },
      practice_county_list: { required },
      attorney_type: { required }
    }
  },
  // calling methos from store to get plan class list from API
  mounted() {
    this.$store.dispatch("getState");
  },
  created() {
    // if attorney logged in and submitted enrollment form.
    this.$store.watch(
      () => this.$store.state.profile_data,
      value => {
        if (value != null) {
          if (this.att_user?.data && this.att_user != undefined) {
            //practices
            if (typeof this.profile_data?.attorney_type == "string") {
              this.form.first_name = this.profile_data?.first_name;
              this.form.attorney_type = this.profile_data?.attorney_type?.split(
                ","
              );
              this.$store.dispatch("getCoverages", this.form.attorney_type);
              this.form.practice_county_list = this.profile_data?.practice_states;
              this.form.credentials = this.profile_data?.credentials;
              for (
                let index = 0;
                index < this.form.credentials.length;
                index++
              ) {
                this.stateList?.forEach(state => {
                  if (state.STATECD == this.form.credentials[index].lic_state) {
                    this.form.credentials[index].lic_state = state;
                  }
                });
                if (this.form.credentials[index].lic_state?.STATECD == "CA") {
                  this.form.stateCount["CA"] = this.form.stateCount["CA"] + 1;
                } else {
                  this.form.stateCount["Others"] =
                    this.form.stateCount["Others"] + 1;
                }
              }

              if (typeof this.profile_data.attr_tags == "string") {
                this.profile_data.attr_tags = JSON.parse(
                  this.profile_data.attr_tags
                );
                if (this.profile_data.attr_tags.length > 0) {
                  this.profile_data.attr_tags.forEach(element => {
                    if (element.text == "Referral-Contingency-Fee") {
                      this.form.referral_cont_fee = true;
                      document.getElementById(
                        "referral_cont_fee"
                      ).checked = true;
                    }
                  });
                }
              }
            }
          }
        }
      }
    );
    // to contiues watch on updates of store's variable
    this.$store.watch(
      () => this.$store.state.coverages,
      value => {
        if (value != undefined) {
          if (value.length > 0) {
            this.coverages = value;
            if (this.att_user?.data && this.att_user != undefined) {
              this.form.remote_consulting = [];
              this.form.remote_services = [];
              setTimeout(() => {
                this.form.id = this.profile_data?.id;
                this.form.coveragelist = this.profile_data?.coverages;
                console.log(this.form.coveragelist, "this.form.coveragelist");
                this.form.coveragelist.forEach(element => {
                  element.desc = element.coverage_id;
                  element.plan_class = element.planclass;
                  element.sub_cov_id = element.subcov_id;
                  if (element.remote_consult == "1") {
                    this.form.remote_consulting.push(element);
                  }
                  if (element.remote_service == "1") {
                    this.form.remote_services.push(element);
                  }
                  setTimeout(() => {
                    for (
                      let index = 0;
                      index < this.coverages.length;
                      index++
                    ) {
                      if (
                        this.coverages[index].sub_coverage &&
                        this.coverages[index].sub_coverage[0]["subcoverage"] !=
                          "" &&
                        this.coverages[index].sub_coverage.length > 1
                      ) {
                        let i = 0;
                        this.coverages[index]?.sub_coverage.forEach(el => {
                          if (element.subcov_id == el.sub_cov_id) {
                            for (
                              let index1 = 0;
                              index1 < this.coverages[index].plan_class.length;
                              index1++
                            ) {
                              if (
                                element.plan_class ==
                                this.coverages[index].plan_class[index1]
                              ) {
                                if(document.getElementById(
                                    "coverage_" + index + "_" + i + "_" + index1
                                  )!=null && document.getElementById(
                                    "coverage_" + index + "_" + i + "_" + index1
                                  )!=undefined){
                                    if (element.deleted != 1) {
                                      document.getElementById(
                                        "coverage_" + index + "_" + i + "_" + index1
                                      ).checked = true;
                                      document.getElementById(
                                        "coverage_" + index + "_" + i + "_" + index1
                                      ).style.border = "solid";
                                    } else {
                                      document.getElementById(
                                        "coverage_" + index + "_" + i + "_" + index1
                                      ).style.border = "solid red";
                                    }
                                  }
                              }
                            }
                           if(element.remote_service == "1"){
                            if(document.getElementById(
                                    "toggle_service" + index + "_" + i
                                  )!=null && document.getElementById(
                                    "toggle_service" + index + "_" + i
                                  )!=undefined){
                              document.getElementById(
                                "toggle_service" + index + "_" + i
                              ).checked = true;
                              }
                           } 
                            if (element.remote_consult == "1") {
                              if(document.getElementById(
                                    "toggle_" + index + "_" + i
                                  )!=null && document.getElementById(
                                    "toggle_" + index + "_" + i
                                  )!=undefined){
                              document.getElementById(
                                "toggle_" + index + "_" + i
                              ).checked = true;
                              }
                            }
                          } else {
                            if (
                              element.desc == this.coverages[index].desc &&
                              element.subcov_id == ""
                            ) {
                              for (
                                let index1 = 0;
                                index1 <
                                this.coverages[index].plan_class.length;
                                index1++
                              ) {
                                if (
                                  element.plan_class ==
                                  this.coverages[index].plan_class[index1]
                                ) {
                                  if(document.getElementById(
                                  "coverage_" + index + "_" + index1
                                )!=undefined && document.getElementById(
                                  "coverage_" + index + "_" + index1
                                )!=null){
                                  if (element.deleted != 1) {
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).checked = true;
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).style.border = "solid";
                                  } else {
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).style.border = "solid red";
                                  }
                                }
                              }
                              }
                              if (element.remote_consult == "1") {
                                if( document.getElementById(
                                  "toggle_" + index
                                )!=null &&  document.getElementById(
                                  "toggle_" + index
                                )!=undefined){
                                  document.getElementById(
                                    "toggle_" + index
                                  ).checked = true;
                                }
                              }
                              if (element.remote_service == "1") {
                                if( document.getElementById(
                                  "toggle_service" + index
                                )!=null &&  document.getElementById(
                                  "toggle_service" + index
                                )!=undefined){
                                  document.getElementById(
                                    "toggle_service" + index
                                  ).checked = true;
                                }
                              }
                            }
                          }
                          i++;
                        });
                      } else {
                        if (element.desc == this.coverages[index].desc) {
                          for (
                            let index1 = 0;
                            index1 < this.coverages[index].plan_class.length;
                            index1++
                          ) {
                            if (
                              element.plan_class ==
                              this.coverages[index].plan_class[index1]
                            ) {
                              if(document.getElementById(
                                  "coverage_" + index + "_" + index1
                                )!=undefined && document.getElementById(
                                  "coverage_" + index + "_" + index1
                                )!=null){
                                  if (element.deleted != 1) {
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).checked = true;
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).style.border = "none";
                                  } else {
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).style.border = "solid red";
                                  }
                                }
                            }
                          }
                          if(document.getElementById(
                              "toggle_" + index
                            )!=undefined && document.getElementById(
                              "toggle_" + index
                            )!=null){
                          if (element.remote_consult == "1") {
                            document.getElementById(
                              "toggle_" + index
                            ).checked = true;
                          }
                        }
                          if(document.getElementById(
                              "toggle_service" + index
                            )!=undefined && document.getElementById(
                              "toggle_service" + index
                            )!=null){
                              if (element.remote_service == "1") {
                            document.getElementById(
                              "toggle_service" + index
                            ).checked = true;
                          }
                        }

                        }
                      }
                    }
                  }, 1000);
                });
              }, 1000);
            } else if (this.tempAttData.is_attorney_exist) {
              setTimeout(() => {
                this.form.coveragelist.forEach(element => {
                  element.subcov_id = element.sub_cov_id;
                  setTimeout(() => {
                    for (
                      let index = 0;
                      index < this.coverages.length;
                      index++
                    ) {
                      if (
                        this.coverages[index].sub_coverage &&
                        this.coverages[index].sub_coverage[0]["subcoverage"] !=
                          "" &&
                        this.coverages[index].sub_coverage.length > 1
                      ) {
                        let i = 0;
                        this.coverages[index].sub_coverage.forEach(el => {
                          if (element.subcov_id == el.sub_cov_id) {
                            for (
                              let index1 = 0;
                              index1 < this.coverages[index].plan_class.length;
                              index1++
                            ) {
                              if (
                                element.plan_class ==
                                this.coverages[index].plan_class[index1]
                              ) {
                                if (element.deleted != 1 || element.deleted) {
                                  document.getElementById(
                                    "coverage_" + index + "_" + i + "_" + index1
                                  ).checked = true;
                                  document.getElementById(
                                    "coverage_" + index + "_" + i + "_" + index1
                                  ).style.border = "solid";
                                } else {
                                  document.getElementById(
                                    "coverage_" + index + "_" + i + "_" + index1
                                  ).style.border = "solid red";
                                }
                              }
                            }
                            if (this.form.remote_services.some(
                              el =>
                                 el.plan_class.length > 0 &&
                                 el.desc == this.coverages[index].desc
                            )) {
                            document.getElementById(
                                "toggle_service" + index + "_" + i
                              ).checked = true;
                            } 
                            if (
                              this.form.remote_consulting.some(
                                el =>
                                  el.plan_class.length > 0 &&
                                  el.desc == this.coverages[index].desc
                              )
                            ) {
                              document.getElementById(
                                "toggle_" + index + "_" + i
                              ).checked = true;
                            }
                          } else {
                            if (
                              element.desc == this.coverages[index].desc &&
                              !element.subcov_id
                            ) {
                              for (
                                let index1 = 0;
                                index1 <
                                this.coverages[index].plan_class.length;
                                index1++
                              ) {
                                if (
                                  element.plan_class ==
                                  this.coverages[index].plan_class[index1]
                                ) {
                                  if (
                                    element.deleted != 1 ||
                                    !element.deleted
                                  ) {
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).checked = true;
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).style.border = "solid";
                                  } else {
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).style.border = "solid red";
                                  }
                                }
                              }
                              if (
                                this.form.remote_consulting.some(
                                  el =>
                                    el.plan_class.length > 0 &&
                                    el.desc == this.coverages[index].desc
                                )
                              ) {
                                document.getElementById(
                                  "toggle_" + index
                                ).checked = true;
                              }
                              if (
                                this.form?.remote_services?.some(
                                  el =>
                                    el.plan_class.length > 0 &&
                                    el.desc == this.coverages[index].desc
                                )
                              ) {
                                document.getElementById(
                                  "toggle_service" + index
                                ).checked = true;
                              }
                            }
                          }
                          i++;
                        });
                      } else {
                        if (element.desc == this.coverages[index].desc) {
                          for (
                            let index1 = 0;
                            index1 < this.coverages[index].plan_class.length;
                            index1++
                          ) {
                            if (
                              element.plan_class ==
                              this.coverages[index].plan_class[index1]
                            ) {
                              if (element.deleted != 1) {
                                document.getElementById(
                                  "coverage_" + index + "_" + index1
                                ).checked = true;
                                document.getElementById(
                                  "coverage_" + index + "_" + index1
                                ).style.border = "none";
                              } else {
                                document.getElementById(
                                  "coverage_" + index + "_" + index1
                                ).style.border = "solid red";
                              }
                            }
                          }
                          if (
                            this.form.remote_consulting.some(
                              el =>
                                el.plan_class.length > 0 &&
                                el.desc == this.coverages[index].desc
                            )
                          ) {
                            document.getElementById(
                              "toggle_" + index
                            ).checked = true;
                          }
                          if (
                            this.form?.remote_services?.some(
                              el =>
                                el.plan_class.length > 0 &&
                                el.desc == this.coverages[index].desc
                            )
                          ) {
                            document.getElementById(
                              "toggle_service" + index
                            ).checked = true;
                          }
                        }
                      }
                    }
                  }, 1000);
                });
              }, 1000);
            }
          }
        } else {
          this.coverages = [];
        }
      }
    );
  },
  //importing resuable components to use in current component
  components: {
    TextInput,
    ConfirmPopup
  },
  // All static methods of this component
  methods: {
    //Code for Add and remove coverage and remote consulting from array
    check: function(data, field, event) {
      console.log("filed",field);
      console.log("data",data);
      console.log("event",event.target.checked);
      // console.log("this.form.remote_consulting",this.form.remote_consulting);
      // console.log("this.form.remote_services",this.form.remote_services);
      if (field == "remote_consulting") {
        if (event.target.checked) {
          this.form.remote_consulting.push(data);
        } else {
          if (data.sub_cov_id != null && data.sub_cov_id != undefined) {
            this.form.remote_consulting = this.form.remote_consulting.filter(
              function(el) {
                return el.sub_cov_id != data.sub_cov_id;
              }
            );
          } else {
            this.form.remote_consulting = this.form.remote_consulting.filter(
              function(el) {
                return el.plan_class != data.plan_class && el.desc != data.desc;
              }
            );
          }

          this.form.remote_consulting = this.form.remote_consulting .filter((value, index, self) =>
               index === self.findIndex((t) => (
              t.sub_cov_id === value.sub_cov_id && t.plan_class === value.plan_class && t.desc === value.desc
          ))
          );
          console.log("--------this.form.remote_consulting",this.form.remote_consulting)
        }
      }else if(field == "remote_services") {
        if (event.target.checked) {
          this.form.remote_services.push(data);
        } else {
          if (data.sub_cov_id != null && data.sub_cov_id != undefined) {
            this.form.remote_services = this.form.remote_services.filter(
              function(el) {
                return el.sub_cov_id != data.sub_cov_id;
              }
            );
          } else {
            this.form.remote_services = this.form.remote_services.filter(
              function(el) {
                return el.plan_class != data.plan_class && el.desc != data.desc;
              }
            );
          }

          this.form.remote_services = this.form.remote_services.filter((value, index, self) =>
               index === self.findIndex((t) => (
              t.sub_cov_id === value.sub_cov_id && t.plan_class === value.plan_class && t.desc === value.desc
          ))
          );
          console.log("--------this.form.remote_services",this.form.remote_services);
        }
      }else if (field == "coveragelist") {
        var today = moment(new Date()).format("YYYY-MM-DD");
        if (event.target.checked) {
          console.log(data);
          if (data.sub_cov_id != null && data.sub_cov_id != undefined) {
            if (
              this.form.coveragelist.some(
                el =>
                  el.plan_class == data.plan_class &&
                  el.desc == data.desc &&
                  el.sub_cov_id == data.sub_cov_id
              )
            ) {
              for (
                let index = 0;
                index < this.form.coveragelist.length;
                index++
              ) {
                if (
                  data.sub_cov_id ==
                    this.form.coveragelist[index]["sub_cov_id"] &&
                  data.plan_class == this.form.coveragelist[index]["plan_class"]
                ) {
                  this.form.coveragelist[index]["new"] = 1;
                }
              }
            } else {
              this.form.coveragelist.push(data);
            }
          } else {
            if (
              this.form.coveragelist.some(
                el =>
                  el.plan_class == data.plan_class &&
                  el.desc == data.desc &&
                  (!el.sub_cov_id ||
                    el.sub_cov_id == null ||
                    el.sub_cov_id == "")
              )
            ) {
              for (
                let index = 0;
                index < this.form.coveragelist.length;
                index++
              ) {
                if (
                  data.plan_class ==
                    this.form.coveragelist[index]["plan_class"] &&
                  data.desc == this.form.coveragelist[index]["desc"] &&
                  this.form.coveragelist[index]["sub_cov_id"] == ""
                ) {
                  console.log(data, "data");
                  this.form.coveragelist[index]["new"] = 1;
                }
              }
            } else {
              this.form.coveragelist.push(data);
            }
          }
        } else {
          if (data.sub_cov_id != null && data.sub_cov_id != undefined) {
            if (
              this.form.coveragelist.some(
                el =>
                  el.sub_cov_id == data.sub_cov_id &&
                  el.plan_class == data.plan_class &&
                  el.desc == data.desc &&
                  el.id != undefined
              )
            ) {
              for (
                let index = 0;
                index < this.form.coveragelist.length;
                index++
              ) {
                if (
                  data.sub_cov_id ==
                    this.form.coveragelist[index]["sub_cov_id"] &&
                  data.plan_class ==
                    this.form.coveragelist[index]["plan_class"] &&
                  data.desc == this.form.coveragelist[index]["desc"]
                ) {
                  console.log(this.form.coveragelist[index], "data");
                  this.form.coveragelist[index]["deleted"] = 1;
                  this.form.coveragelist[index]["date_deleted"] = today;
                }
              }
            } else {
              this.form.coveragelist = this.form.coveragelist.filter(function(
                el
              ) {
                if (
                  el.sub_cov_id == data.sub_cov_id &&
                  el.plan_class == data.plan_class &&
                  el.desc == data.desc
                ) {
                  return false;
                } else {
                  return true;
                }
              });
            }
          } else {
            if (
              this.form.coveragelist.some(
                el =>
                  el.plan_class == data.plan_class &&
                  el.id != undefined &&
                  el.desc == data.desc
              )
            ) {
              for (
                let index = 0;
                index < this.form.coveragelist.length;
                index++
              ) {
                if (
                  data.plan_class ==
                    this.form.coveragelist[index]["plan_class"] &&
                  data.desc == this.form.coveragelist[index]["desc"] &&
                  this.form.coveragelist[index]["sub_cov_id"] == ""
                ) {
                  console.log(this.form.coveragelist[index], "data");
                  this.form.coveragelist[index]["deleted"] = 1;
                  this.form.coveragelist[index]["date_deleted"] = today;
                  console.log(data, "data");
                }
              }
            } else {
              console.log(data);
              this.form.coveragelist = this.form.coveragelist.filter(function(
                el
              ) {
                if (
                  el.plan_class == data.plan_class &&
                  el.desc == data.desc &&
                  (!el.sub_cov_id ||
                    el.sub_cov_id == null ||
                    el.sub_cov_id == "")
                ) {
                  return false;
                } else {
                  return true;
                }
              });
            }
          }
        }
        console.log(this.form.coveragelist, "this.form.coveragelist");
      }
    },
    getCoverages: function(value) {
      this.$store.dispatch("getCoverages", this.form.attorney_type);
      if (value != "CDL") {
        if (
          this.form.attorney_type.includes("FAM") &&
          this.form.attorney_type.includes("REF")
        ) {
          this.openCovDetail(true);
        }
      }
    },
    openCovDetail: function(value) {
      if (value) {
        document.getElementById("covModal").removeAttribute("class");
      } else {
        document.getElementById("covModal").setAttribute("class", "hidden");
      }
    },
    // Filter dropdown list on Dropdown based on typed value
    searchAutocomplete: function(event, field) {
      if (field == "state") {
        let statesLicense = [];
        this.form.credentials.forEach(element => {
          statesLicense.push({
            state_name: element.lic_state.state_name,
            STATECD: element.lic_state.STATECD
          });
        });
        console.log(this.form.credentials);
        if (!event.query.trim().length) {
          this.state_list = [...statesLicense];
        } else {
          this.state_list = statesLicense.filter(item => {
            return item.state_name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
        var result = this.state_list.reduce((unique, o) => {
          if (!unique.some(obj => obj.state_name === o.state_name)) {
            unique.push(o);
          }
          return unique;
        }, []);
        this.state_list = result;
      } else if (field == "county") {
        if (!event.query.trim().length) {
          this.county_list = [...this.countyList];
          this.county_list.unshift({'COUNTYNAME':'All Counties'});
        } else {
          this.county_list = this.countyList.filter(item => {
            return item.COUNTYNAME.toLowerCase().startsWith(
              event.query.toLowerCase()
            );
          });
        }
      } else if (field == "attorney_planclass") {
        console.log(this.form.coveragelist);
        if (!event.query.trim().length) {
          this.att_plan_list = [...this.form.coveragelist];
        } else {
          this.att_plan_list = this.form.coveragelist.filter(item => {
            console.log(item);
            return item.plan_class
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
        var result1 = this.att_plan_list.reduce((unique, o) => {
          if (!unique.some(obj => obj.plan_class === o.plan_class)) {
            unique.push(o);
          }
          return unique;
        }, []);
        this.att_plan_list = result1;
      }
    },
    //On Click View More button opening modal to display fee details
    openfeeSchedule: function(value, data = null) {
      if (value) {
        this.fee_schedule_data = data;
        document.getElementById("feeModal").removeAttribute("class");
      } else {
        document.getElementById("feeModal").setAttribute("class", "hidden");
      }
    },
    // code to download pdf
    download: function(path) {
      window.open(path);
    },
    //Submit and Validate form
    submitApplication: function() {
      this.v$.form.$touch(this.v$.form.errors);
      if (this.v$.form.$pending || this.v$.form.$error) return;
      if (
        this.form.referral_cont_fee != null ||
        this.form.referral_cont_fee != ""
      ) {
        if (this.form.referral_cont_fee == true) {
          this.form.attr_tags = JSON.stringify([
            { text: "Referral-Contingency-Fee" }
          ]);
          console.log(this.form.attr_tags);
        }
      }
      
    },
    // On Select State calling method from store to get County list based on State
    onSelect: function(event, field) {
      if (field == "state") {
        this.$store.dispatch("getCounty", event.value.STATECD);
      }
    },
    // Code to add more practice county
    add_county: function() {
      if (
        this.form.prac_state == "" ||
        this.form.county == "" ||
        this.form.county == null ||
        this.form.att_plan_class == "" ||
        this.form.att_plan_class == null ||
        this.form.prac_state == null
      ) {
        this.$toast.error("Please select State and County!");
      } else {
        console.log(this.form.att_plan_class.plan_class);
        console.log(this.form.prac_state.STATECD);
        console.log(this.form.county.COUNTYNAME)
        console.log(this.form.practice_county_list)
        if (
          this.form.practice_county_list.some(
            el => (el.state_code == this.form.prac_state.STATECD) && (el.county == this.form.county.COUNTYNAME) && (el.plan_class == this.form.att_plan_class.plan_class)
          )
        ) {
          this.$toast.error("Duplicate Practice County");
        } else {
          if(this.form.county.COUNTYNAME=='All Counties'){
            this.county_list.forEach(element => {
              if (this.form.practice_county_list.some(
              el => el.state_code == this.form.prac_state.STATECD
              && el.county == element.COUNTYNAME
              && el.plan_class == this.form.att_plan_class.plan_class)) 
              {
               //
               console.log("duplicate");
              }else{
                 if(element.COUNTYNAME!="All Counties"){
                  this.form.practice_county_list.push({
                state_code: this.form.prac_state.STATECD,
                county:  element.COUNTYNAME,
                plan_class: this.form.att_plan_class.plan_class,
                date_deleted: ""
              });
                }
              }
            });
          }else{
            this.form.practice_county_list.push({
              state_code: this.form.prac_state.STATECD,
              county: this.form.county.COUNTYNAME,
              plan_class: this.form.att_plan_class.plan_class,
              date_deleted: ""
            });
          }
          console.log(this.form.practice_county_list);
        }
      }
      this.form.prac_state = null;
      this.form.county = null;
      this.form.att_plan_class = null;
    },
    addCounty: function(index) {
      this.form.practice_county_list[index].deleted = 0;
      this.form.practice_county_list[index]["date_deleted"] = "";
    },
    // Code to remove practice county from county array
    remove_county: function() {
      var today = moment(new Date()).format("YYYY-MM-DD");
      if (
        this.form.practice_county_list.some(
          el =>
            el.state_code == this.deleteCountyData.state_code &&
            el.id != undefined
        ) &&
        this.form.practice_county_list.some(
          el =>
            el.plan_class == this.deleteCountyData.plan_class &&
            el.id != undefined
        ) &&
        this.form.practice_county_list.some(
          el => el.county == this.deleteCountyData.county && el.id != undefined
        )
      ) {
        for (
          let index = 0;
          index < this.form.practice_county_list.length;
          index++
        ) {
          if (
            this.deleteCountyData.state_code ==
              this.form.practice_county_list[index]["state_code"] &&
            this.deleteCountyData.plan_class ==
              this.form.practice_county_list[index]["plan_class"] &&
            this.deleteCountyData.county ==
              this.form.practice_county_list[index]["county"]
          ) {
            this.form.practice_county_list[index]["deleted"] = 1;
            this.form.practice_county_list[index]["date_deleted"] = today;
          }
        }
      } else {
        this.form.practice_county_list.splice(this.deleteCountyIndex, 1);
      }
      console.log(this.form.practice_county_list);
    },
    //On cancel modal of delete
    cancelModal: function() {
      this.showCountyDeleteModal = false;
    },
    // confirmation modal for delete practice county
    ConfirmCountyDelete: function(index, data) {
      this.showCountyDeleteModal = true;
      this.deleteCountyIndex = index;
      this.deleteCountyData = data;
    },
    setDateFormat: function(date) {
      if (date != null && date != "") {
        return moment(date).format("MMM DD YYYY");
      }
    }
  }
};
</script>
